import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgBell = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M10.2222 20.6666C10.3351 21.0512 10.5695 21.3889 10.8904 21.6291C11.2113 21.8693 11.6013 21.9991 12.0022 21.9991C12.403 21.9991 12.7931 21.8693 13.1139 21.6291C13.4348 21.3889 13.6693 21.0512 13.7822 20.6666"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 3.99988V1.99988"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 3.99988C13.7681 3.99988 15.4638 4.70226 16.714 5.9525C17.9643 7.20274 18.6667 8.89843 18.6667 10.6665C18.6667 16.9297 20 17.9999 20 17.9999H4C4 17.9999 5.33333 16.2968 5.33333 10.6665C5.33333 8.89843 6.03571 7.20274 7.28595 5.9525C8.5362 4.70226 10.2319 3.99988 12 3.99988V3.99988Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgBell.displayName = 'SvgBell';
export default SvgBell;
